import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute("/_layout/templates")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "canned_work_package:read", "/"),
})
